import { featuresProd } from './featuresProd';
import { featuresQA } from './featuresQA';
import { featuresDev } from './featuresDev';
import { featuresStage } from './featuresStage';
import { AppConfigs } from '../config';

export const config: AppConfigs = {
  configs: {
    dev: {
      features: featuresDev,
    },
    qa: {
      features: featuresQA,
    },
    stage: {
      features: featuresStage,
    },
    prod: {
      features: featuresProd,
    },
  },
};
